import { Suspense } from 'react';
import { useActionData, useNavigation, Form, Link, Await, useRouteLoaderData } from 'react-router-dom';
import AdminTeamsForm from '../../components/admin/AdminTeamsForm.jsx'
import AdminTeamsShow from '../../components/admin/AdminTeamsShow.jsx'
import { GetTeam } from "../../repo/TeamsRepo.js";
import { ListImages } from "../../repo/ImagesRepo.js"
import { TeamUpdate } from "../../repo/TeamsRepo.js";

export default function TeamEditPage() {
  const responseSave = useActionData()
  const responseLoad = useRouteLoaderData('admin-team-edit')
  const createNavigation = useNavigation()
  const isSubmitting = createNavigation.state === 'submitting'

  return (
    <section className="m-8">
      {responseSave && responseSave.status && responseSave.status  ? (
        <AdminTeamsShow team={responseSave.data} status="updated"/>
      ) : (
        <>
          <h1>Edit Team</h1>
          <div id="team-create-form" className={`w-full py-4 mb-4'`}>
            <Form method="PUT" className="space-y-4 md:space-y-6 mt-4">
              <Suspense fallback={<p>Carregando...</p>}>
                <Await resolve={responseLoad}>
                  {(loadedResponse) => <AdminTeamsForm team={loadedResponse.team} images={loadedResponse.images.data} errors={(responseSave && responseSave.errors) ? responseSave.errors : null } isSubmitting={isSubmitting}/>}
                </Await>
              </Suspense>
            </Form>
          </div>

          <div id="teams" className={`w-full pt-4 mt-4'`}>
            <Link className="hover:no-underline underline" to="/cocofantoelefanto/teams">Back to Teams</Link>
          </div>
        </>
      )}
    </section>
  )
}

export async function action({request}) {
  const data = await request.formData()

  const teamData = {
    team: {
      name: data.get('name'),
      image_id: data.get('image_id'),
      third_party_label: data.get('third_party_label'),
      third_party_id: data.get('third_party_id')
    }
  }

  return await TeamUpdate(data.get('id'), teamData)
}

export async function loader({ params, request }) {
  return {
    team: await GetTeam(params.id),
    images: await ListImages(1, { skip_confirmation: 1 })
  }
}
